/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [leave-space-dialog.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 05.04.20, 18:41
 */

import React, {useState} from 'react';
import {useAuthorization} from "../../../selectors";
import {useLanguage} from "../../configuration/configuration";
import {PENDING_STATUS} from "../../../actions";
import useAsyncUpdateStatus from "../../hooks/async-update-status";
import {Spinner} from "../../util/spinner";
import {NavigationGroup, NavigationRow} from "../../navigation/layout/nav-layout";
import {Close, SendRounded} from "@material-ui/icons";
import {RoundedButton} from "../../navigation/buttons/nav-buttons";

const UpdateStatusPopover = ({user, onClose}) => {
    const [dailyStatus, setDailyStatus] = useState('');
    const {isAuthorized} = useAuthorization();
    const {updateStatus, status} = useAsyncUpdateStatus();
    const Lang = useLanguage();


    const handleOnStatusChange = (event) => {
        event.preventDefault();
        setDailyStatus(event.target.value);
    }

    const handleOnUpdate = (event) => {
        event.preventDefault();
        isAuthorized && updateStatus(dailyStatus);
    }

    if (status === PENDING_STATUS) return <Spinner/>

    return <div className='px-2 py-1'>
        <NavigationRow>
            <NavigationGroup>
                <h4 className='clr-popover-search'>{Lang.dialog.updateStatus.label}</h4>
            </NavigationGroup>
            <NavigationGroup>
                <button className='btn btn-outline-primary m-0 p-1' onClick={onClose}>
                    <Close className='clr-popover-search'/>
                </button>
            </NavigationGroup>
        </NavigationRow>

        <div className='small'>
            {Lang.dialog.popoverStatus.text(user.firstname)}
        </div>
        <div className='box-aligned my-1'>
            <textarea className='form-control form-textarea'
                      value={dailyStatus}
                      name='dailyStatus'
                      type='text'
                      placeholder={Lang.dialog.popoverStatus.placeholder}
                      id='statusId'
                      onChange={handleOnStatusChange}/>
            <RoundedButton className='btn-outline-primary ml-2'
                            title={Lang.dialog.popoverStatus.action}
                           onClick={handleOnUpdate}>
                <SendRounded className='clr-white pl-1'/>
            </RoundedButton>
        </div>
    </div>
};

export default UpdateStatusPopover;